import { z } from 'zod';
import { Language } from './constants';

export const languageSchema = z.enum(Language);
